import { useEffect } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { payment } from "../../../../../store";
import {
  PaymentResultLayout,
  PaymentResultDetails,
  PaymentFailIcon,
} from "../paymentResult";
import { trackPaymentFailed } from "../../../../../utils/analytics";

export function FailPage() {
  const [searchParams] = useSearchParams();
  const { course_id, user_id } = useParams();
  const failPayment = payment((state) => state.failPayment);

  useEffect(() => {
    const code = searchParams.get("code");
    const message = searchParams.get("message");
    // 토스가 orderId를 안 넘기는 경우를 대비해 Cart에서 보관해둔 값으로 폴백한다.
    const orderId =
      searchParams.get("orderId") ||
      sessionStorage.getItem("pending_payment_order_id");

    trackPaymentFailed(code, message, course_id);

    // 결제 실패를 서버에 기록해 관리자 화면에서 '이탈(READY)'과 구분되게 한다.
    if (orderId) {
      failPayment(orderId, code, message);
      sessionStorage.removeItem("pending_payment_order_id");
    }
  }, [searchParams, course_id, failPayment]);

  const detailItems = [
    { label: "에러 코드", value: searchParams.get("code") },
    { label: "실패 사유", value: searchParams.get("message") },
  ];

  return (
    <PaymentResultLayout
      variant="fail"
      icon={<PaymentFailIcon />}
      title="결제에 실패했습니다"
      subtitle="결제가 완료되지 않았습니다. 아래 안내를 확인한 뒤 다시 시도해 주세요."
      actions={
        <>
          <Link
            to={`/cart/${user_id}/${course_id}`}
            className="payment-result-card__btn payment-result-card__btn--primary"
          >
            다시 결제하기
          </Link>
          <Link
            to={course_id ? `/courses/${course_id}` : "/courses"}
            className="payment-result-card__btn payment-result-card__btn--secondary"
          >
            강의 상세로 돌아가기
          </Link>
        </>
      }
    >
      <PaymentResultDetails items={detailItems} />
    </PaymentResultLayout>
  );
}
